module.exports = __webpack_public_path__ + "static/media/3dots-icon.53c0ad85.svg";